import { render, staticRenderFns } from "./dui-option-picker.vue?vue&type=template&id=060195dd&scoped=true&"
import script from "./dui-option-picker.vue?vue&type=script&lang=js&"
export * from "./dui-option-picker.vue?vue&type=script&lang=js&"
import style0 from "./dui-option-picker.vue?vue&type=style&index=0&id=060195dd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060195dd",
  null
  
)

export default component.exports